import { checkVisibilityAllowed } from '@/defineAbility'
import type { navItem } from '@/navigation/vertical'

/**
 * DEVAMS-2670 (second-round review): extracted from VerticalNav.vue /
 * NavFavoritesRail.vue, which each had their own copy of this predicate. Now
 * also reused by Footer.vue's phone bottom tab bar so all three
 * favorites/nav surfaces apply the exact same permission gating.
 *
 * An item with no `anyOf` is always visible (authenticated users only — the
 * router guard ensures these components never render without a valid
 * session). DEVAMS-2025 origin.
 */
export function isNavItemVisible(item: navItem): boolean {
  if (!item.anyOf || item.anyOf.length === 0) return true
  return item.anyOf.some(p => checkVisibilityAllowed(p.permission, p.operation ?? 'read'))
}
